import { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../api';
import Layout from '../components/Layout';

export default function Lavoratori() {
  const { utente } = useAuth();
  const [lavoratori, setLavoratori] = useState([]);
  const [cerca, setCerca] = useState('');
  const [totale, setTotale] = useState(0);
  const [mostraForm, setMostraForm] = useState(false);
  const [modifica, setModifica] = useState(null);
  const [mostraImport, setMostraImport] = useState(false);
  const [aziende, setAziende] = useState([]);
  const [aziendaFiltro, setAziendaFiltro] = useState('');

  const caricaLavoratori = useCallback(async () => {
    try {
      const params = {};
      if (cerca) params.cerca = cerca;
      if (aziendaFiltro) params.azienda_id = aziendaFiltro;
      const res = await api.get('/lavoratori', { params });
      setLavoratori(res.data.lavoratori);
      setTotale(res.data.totale);
    } catch (err) {
      console.error(err);
    }
  }, [cerca, aziendaFiltro]);

  useEffect(() => { caricaLavoratori(); }, [caricaLavoratori]);

  useEffect(() => {
    if (utente.ruolo === 'studio') {
      api.get('/aziende').then(res => setAziende(res.data)).catch(() => {});
    }
  }, [utente.ruolo]);

  const eliminaLavoratore = async (id) => {
    if (!window.confirm('Disattivare questo lavoratore?')) return;
    await api.delete(`/lavoratori/${id}`);
    caricaLavoratori();
  };

  return (
    <Layout>
      <div style={styles.topBar}>
        <h2 style={{ margin: 0 }}>Lavoratori ({totale})</h2>
        <div style={styles.actions}>
          <button onClick={() => setMostraImport(true)} style={styles.btnSecondary}>Importa Excel/CSV</button>
          <button onClick={() => { setModifica(null); setMostraForm(true); }} style={styles.btn}>+ Nuovo Lavoratore</button>
        </div>
      </div>

      <div style={styles.filtri}>
        <input
          type="text"
          placeholder="Cerca per nome, cognome o codice fiscale..."
          value={cerca}
          onChange={e => setCerca(e.target.value)}
          style={styles.inputCerca}
        />
        {utente.ruolo === 'studio' && (
          <select value={aziendaFiltro} onChange={e => setAziendaFiltro(e.target.value)} style={styles.select}>
            <option value="">Tutte le aziende</option>
            {aziende.map(a => <option key={a.id} value={a.id}>{a.ragione_sociale}</option>)}
          </select>
        )}
      </div>

      <div style={styles.tableWrapper}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>Lavoratore</th>
              <th style={styles.th}>Cod. Fiscale</th>
              {utente.ruolo === 'studio' && <th style={styles.th}>Azienda</th>}
              <th style={styles.th}>Tipo Assunzione</th>
              <th style={styles.th}>Tipologia Contratto</th>
              <th style={styles.th}>Mansione</th>
              <th style={styles.th}>Liv.</th>
              <th style={styles.th}>P.T.</th>
              <th style={styles.th}>Data Ass.</th>
              <th style={styles.th}>Scadenza</th>
              <th style={styles.th}>Azioni</th>
            </tr>
          </thead>
          <tbody>
            {lavoratori.map(l => (
              <tr key={l.id} style={styles.tr}>
                <td style={styles.td}><strong>{l.cognome}</strong> {l.nome}</td>
                <td style={styles.td}>{l.codice_fiscale}</td>
                {utente.ruolo === 'studio' && <td style={styles.td}>{l.ragione_sociale}</td>}
                <td style={styles.td}>{l.tipo_assunzione || '-'}</td>
                <td style={styles.td}>{l.tipologia_contratto || '-'}</td>
                <td style={styles.td}>{l.mansione || '-'}</td>
                <td style={styles.td}>{l.livello || '-'}</td>
                <td style={styles.td}>{l.part_time ? `${l.part_time}%` : '-'}</td>
                <td style={styles.td}>{l.data_assunzione ? new Date(l.data_assunzione).toLocaleDateString('it-IT') : '-'}</td>
                <td style={styles.td}>{l.data_termine_contratto ? new Date(l.data_termine_contratto).toLocaleDateString('it-IT') : '-'}</td>
                <td style={styles.td}>
                  <button onClick={() => { setModifica(l); setMostraForm(true); }} style={styles.btnSmall}>Modifica</button>
                  <button onClick={() => eliminaLavoratore(l.id)} style={styles.btnSmallDanger}>Disattiva</button>
                </td>
              </tr>
            ))}
            {lavoratori.length === 0 && (
              <tr><td colSpan={utente.ruolo === 'studio' ? 11 : 10} style={{ ...styles.td, textAlign: 'center', color: '#999' }}>Nessun lavoratore trovato</td></tr>
            )}
          </tbody>
        </table>
      </div>

      {mostraForm && (
        <FormLavoratore
          lavoratore={modifica}
          aziende={aziende}
          utente={utente}
          onChiudi={() => { setMostraForm(false); setModifica(null); }}
          onSalvato={() => { setMostraForm(false); setModifica(null); caricaLavoratori(); }}
        />
      )}
      {mostraImport && (
        <ImportLavoratori
          aziende={aziende}
          utente={utente}
          onChiudi={() => setMostraImport(false)}
          onImportato={() => { setMostraImport(false); caricaLavoratori(); }}
        />
      )}
    </Layout>
  );
}

function FormLavoratore({ lavoratore, aziende, utente, onChiudi, onSalvato }) {
  const [form, setForm] = useState(
    lavoratore
      ? { ...lavoratore, data_assunzione: lavoratore.data_assunzione?.split('T')[0] || '', data_termine_contratto: lavoratore.data_termine_contratto?.split('T')[0] || '' }
      : { nome: '', cognome: '', codice_fiscale: '', email: '', tipo_assunzione: '', tipologia_contratto: '', mansione: '', livello: '', part_time: '', data_assunzione: '', data_termine_contratto: '', azienda_id: '' }
  );
  const [errore, setErrore] = useState('');
  const [salvataggio, setSalvataggio] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrore('');
    setSalvataggio(true);
    try {
      if (lavoratore) {
        await api.put(`/lavoratori/${lavoratore.id}`, form);
      } else {
        await api.post('/lavoratori', form);
      }
      onSalvato();
    } catch (err) {
      setErrore(err.response?.data?.errore || 'Errore nel salvataggio');
    } finally {
      setSalvataggio(false);
    }
  };

  const aggiorna = (campo, valore) => setForm(prev => ({ ...prev, [campo]: valore }));

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <h3>{lavoratore ? 'Modifica Lavoratore' : 'Nuovo Lavoratore'}</h3>
        <form onSubmit={handleSubmit}>
          {errore && <div style={styles.errore}>{errore}</div>}
          {utente.ruolo === 'studio' && !lavoratore && (
            <div style={styles.campo}>
              <label>Azienda</label>
              <select value={form.azienda_id} onChange={e => aggiorna('azienda_id', e.target.value)} required style={styles.input}>
                <option value="">Seleziona azienda</option>
                {aziende.map(a => <option key={a.id} value={a.id}>{a.ragione_sociale}</option>)}
              </select>
            </div>
          )}
          {['cognome', 'nome'].map(campo => (
            <div key={campo} style={styles.campo}>
              <label>{campo.charAt(0).toUpperCase() + campo.slice(1)}</label>
              <input type="text" value={form[campo]} onChange={e => aggiorna(campo, e.target.value)} required style={styles.input} />
            </div>
          ))}
          <div style={styles.campo}>
            <label>Codice Fiscale</label>
            <input type="text" value={form.codice_fiscale} onChange={e => aggiorna('codice_fiscale', e.target.value.toUpperCase())} required maxLength={16} style={styles.input} />
          </div>
          <div style={styles.campo}>
            <label>Email</label>
            <input type="email" value={form.email || ''} onChange={e => aggiorna('email', e.target.value)} style={styles.input} placeholder="email@esempio.it" />
          </div>
          <div style={styles.campo}>
            <label>Tipo Assunzione</label>
            <select value={form.tipo_assunzione || ''} onChange={e => aggiorna('tipo_assunzione', e.target.value)} style={styles.input}>
              <option value="">— Seleziona —</option>
              <option value="Normale">Normale</option>
              <option value="Lavoro a chiamata">Lavoro a chiamata</option>
            </select>
          </div>
          <div style={styles.campo}>
            <label>Tipologia Contratto</label>
            <select value={form.tipologia_contratto || ''} onChange={e => aggiorna('tipologia_contratto', e.target.value)} style={styles.input}>
              <option value="">— Seleziona —</option>
              <option value="Lavoro dipendente a tempo indeterminato">Lavoro dipendente a tempo indeterminato</option>
              <option value="Lavoro dipendente a tempo determinato">Lavoro dipendente a tempo determinato</option>
              <option value="Stagionale">Stagionale</option>
            </select>
          </div>
          <div style={styles.campo}>
            <label>Mansione</label>
            <input type="text" value={form.mansione} onChange={e => aggiorna('mansione', e.target.value)} style={styles.input} />
          </div>
          <div style={styles.campo}>
            <label>Livello</label>
            <input type="text" value={form.livello} onChange={e => aggiorna('livello', e.target.value)} style={styles.input} />
          </div>
          <div style={styles.campo}>
            <label>Part-Time (%)</label>
            <input type="number" min="0" max="100" value={form.part_time} onChange={e => aggiorna('part_time', e.target.value)} style={styles.input} placeholder="0 = full time / chiamata" />
          </div>
          <div style={styles.campo}>
            <label>Data Assunzione</label>
            <input type="date" value={form.data_assunzione} onChange={e => aggiorna('data_assunzione', e.target.value)} style={styles.input} />
          </div>
          <div style={styles.campo}>
            <label>Data Termine Contratto</label>
            <input type="date" value={form.data_termine_contratto} onChange={e => aggiorna('data_termine_contratto', e.target.value)} style={styles.input} />
          </div>

          <div style={styles.modalActions}>
            <button type="button" onClick={onChiudi} style={styles.btnSecondary}>Annulla</button>
            <button type="submit" disabled={salvataggio} style={styles.btn}>
              {salvataggio ? 'Salvataggio...' : 'Salva'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

function ImportLavoratori({ aziende, utente, onChiudi, onImportato }) {
  const [file, setFile] = useState(null);
  const [aziendaId, setAziendaId] = useState('');
  const [risultato, setRisultato] = useState(null);
  const [caricamento, setCaricamento] = useState(false);
  const [errore, setErrore] = useState('');

  const handleImport = async (e) => {
    e.preventDefault();
    setErrore('');
    setCaricamento(true);
    try {
      const formData = new FormData();
      formData.append('file', file);
      if (utente.ruolo === 'studio') formData.append('azienda_id', aziendaId);
      const res = await api.post('/lavoratori/import', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setRisultato(res.data);
    } catch (err) {
      setErrore(err.response?.data?.errore || 'Errore durante l\'import');
    } finally {
      setCaricamento(false);
    }
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <h3>Importa Lavoratori da Excel/CSV</h3>
        {!risultato ? (
          <form onSubmit={handleImport}>
            {errore && <div style={styles.errore}>{errore}</div>}
            <p style={{ color: '#666', fontSize: '0.9rem' }}>
              Il file deve contenere le colonne: <strong>Cognome Dipendente</strong>, <strong>Nome Dipendente</strong>, <strong>Codice Fiscale Dipendente</strong>, <strong>Codice Fiscale Azienda</strong> (per associazione automatica)
            </p>
            {utente.ruolo === 'studio' && (
              <div style={styles.campo}>
                <label>Azienda</label>
                <select value={aziendaId} onChange={e => setAziendaId(e.target.value)} required style={styles.input}>
                  <option value="">Seleziona azienda</option>
                  {aziende.map(a => <option key={a.id} value={a.id}>{a.ragione_sociale}</option>)}
                </select>
              </div>
            )}
            <div style={styles.campo}>
              <label>File Excel (.xlsx) o CSV</label>
              <input type="file" accept=".xlsx,.xls,.csv" onChange={e => setFile(e.target.files[0])} required style={styles.input} />
            </div>
            <div style={styles.modalActions}>
              <button type="button" onClick={onChiudi} style={styles.btnSecondary}>Annulla</button>
              <button type="submit" disabled={caricamento} style={styles.btn}>
                {caricamento ? 'Importazione...' : 'Importa'}
              </button>
            </div>
          </form>
        ) : (
          <div>
            <p style={{ color: '#2a9d8f', fontWeight: 'bold' }}>Importati: {risultato.inseriti} lavoratori</p>
            {risultato.errori.length > 0 && (
              <div>
                <p style={{ color: '#c00', fontWeight: 'bold' }}>Errori ({risultato.errori.length}):</p>
                <ul style={{ maxHeight: '200px', overflow: 'auto', fontSize: '0.85rem' }}>
                  {risultato.errori.map((e, i) => (
                    <li key={i}>Riga {e.riga}: {e.motivo}</li>
                  ))}
                </ul>
              </div>
            )}
            <div style={styles.modalActions}>
              <button onClick={onImportato} style={styles.btn}>Chiudi</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

const styles = {
  topBar: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem', flexWrap: 'wrap', gap: '1rem' },
  actions: { display: 'flex', gap: '0.5rem' },
  filtri: { display: 'flex', gap: '1rem', marginBottom: '1rem', flexWrap: 'wrap' },
  inputCerca: { flex: 1, minWidth: '250px', padding: '0.6rem', border: '1px solid #ddd', borderRadius: '6px', fontSize: '0.95rem' },
  select: { padding: '0.6rem', border: '1px solid #ddd', borderRadius: '6px', fontSize: '0.95rem', minWidth: '180px' },
  tableWrapper: { overflowX: 'auto' },
  table: { width: '100%', borderCollapse: 'collapse', background: 'white', borderRadius: '8px', overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,0.08)' },
  th: { textAlign: 'left', padding: '0.6rem 0.7rem', background: '#f8f9fa', borderBottom: '2px solid #eee', fontSize: '0.8rem', color: '#555', whiteSpace: 'nowrap' },
  tr: { borderBottom: '1px solid #f0f0f0' },
  td: { padding: '0.5rem 0.7rem', fontSize: '0.85rem' },
  btn: { background: '#232323', color: 'white', border: 'none', padding: '0.6rem 1.2rem', borderRadius: '6px', cursor: 'pointer', fontSize: '0.9rem' },
  btnSecondary: { background: 'white', color: '#333', border: '1px solid #ddd', padding: '0.6rem 1.2rem', borderRadius: '6px', cursor: 'pointer', fontSize: '0.9rem' },
  btnSmall: { background: '#eef', color: '#232323', border: 'none', padding: '0.3rem 0.7rem', borderRadius: '4px', cursor: 'pointer', marginRight: '0.3rem', fontSize: '0.8rem' },
  btnSmallDanger: { background: '#fee', color: '#c00', border: 'none', padding: '0.3rem 0.7rem', borderRadius: '4px', cursor: 'pointer', fontSize: '0.8rem' },
  overlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 },
  modal: { background: 'white', padding: '2rem', borderRadius: '12px', width: '100%', maxWidth: '500px', maxHeight: '90vh', overflow: 'auto' },
  campo: { marginBottom: '1rem' },
  input: { width: '100%', padding: '0.6rem', border: '1px solid #ddd', borderRadius: '6px', fontSize: '0.95rem', boxSizing: 'border-box', marginTop: '0.3rem' },
  modalActions: { display: 'flex', justifyContent: 'flex-end', gap: '0.5rem', marginTop: '1.5rem' },
  errore: { background: '#fee', color: '#c00', padding: '0.7rem', borderRadius: '6px', marginBottom: '1rem' },
};
